<template>
    <div>
        <component :config='config' :result="resultData.result" :is='delegate'></component>
    </div>
</template>
<script>
export default {
    name: 'Delegator',
    inject: ['resultData'],
    props: {
        config: {
            type: Object,
            default: () => {return {}}
        }
    },
    data () {
        return {
            delegate: null
        }
    },
    components: {
    },
    created () {
        this.delegate = () => import(`../../${this.config.to}.vue`)
    }
}
</script>
